// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__gFPdT","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__wo3q3"};